var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.699,
    height: 9.699,
    viewBox: "0 0 9.699 9.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35781",
    "data-name": "Group 35781",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35858",
    "data-name": "Path 35858",
    d: "M8.664,2.226H7.532A1.391,1.391,0,0,0,6.419,0,1.249,1.249,0,0,0,5.347.521a5.4,5.4,0,0,0-.6,1.237,5.4,5.4,0,0,0-.6-1.237A1.249,1.249,0,0,0,3.08,0,1.391,1.391,0,0,0,1.967,2.226H.835A.836.836,0,0,0,0,3.061v.557A.836.836,0,0,0,.557,4.4V8.664a.836.836,0,0,0,.835.835H8.108a.836.836,0,0,0,.835-.835V4.4A.836.836,0,0,0,9.5,3.618V3.061A.836.836,0,0,0,8.664,2.226ZM5.26,1.98C5.687.9,5.849.557,6.419.557a.835.835,0,1,1,0,1.67H5.163ZM3.08.557C3.65.557,3.812.9,4.239,1.98l.1.246H3.08a.835.835,0,1,1,0-1.67Zm.557,8.386H1.391a.279.279,0,0,1-.278-.278V4.453H3.636Zm0-5.046H.835a.279.279,0,0,1-.278-.278V3.061a.279.279,0,0,1,.278-.278h2.8Zm1.67,5.046H4.193V2.783H5.306Zm3.08-.278a.279.279,0,0,1-.278.278H5.863V4.453H8.386Zm.557-5.046a.279.279,0,0,1-.278.278h-2.8V2.783h2.8a.279.279,0,0,1,.278.278Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardIcon);
export default __webpack_public_path__ + "static/media/reward-icon.6de4dfe607dff4a131f91b911d04243d.svg";
export { ForwardRef as ReactComponent };